import UserSignin from "app/user/sign-in";
// import AccountInfo from "./user/sign-up/account_info";
import ForgotPwd from "./user/forgot-password";
import ResetPwd from "./user/reset-password";
import UploadVouchers from "./campaigns/upload_voucher";
import CampaignOrders from "./campaigns/orders";
import CampaignOverview from "./campaigns/overview";
import CampaignView from "./campaigns/view";
import ChurnCampaignView from "./churn_campaigns/view";
import ChurnCustomers from "./churn_campaigns/customers";
import ChurnCampaignPayments from "./churn_campaigns/payments";
import MessagingCampaignView from "./broadcast_campaigns/view";
import AgentGroup from "./agents/groups/view";
import ContactInfo from "./user/sign-up/user_info";
import SignUp from "./user/sign-up";
import CreateDataForm from "./data_forms/create";
import EditDataForm from "./data_forms/view";
import AccountProduct from "./products/view";
import CampaignAgentPerformance from "./campaigns/agent_performance";
import ShippingRateViewPage from "./shipping_rates/view";
import OrderPage from "./campaigns/order";
import TrainingCourse from "./trainings/view";
import CourseTest from "./trainings/quiz";
import LocationCheckIns from "./campaigns/location_check_ins";
import DataCapturesPage from "./campaigns/data_captures";
import DataCapturePage from "./campaigns/data_captures/view";
import DataCampaignOverview from "./campaigns/data_captures/overview";
import LicensePurchasePage from "./agents/licenses/view";
// import CreateAdvertPage from "./promote/create";
// import AdvertViewPage from "./promote/view";
import CampaignLocationAttendancesPage from "./campaigns/location_attendances";
import AttendanceViewPage from "./attendances/view";
import AttendanceEntriesPage from "./attendances/records";
import CustomerPoolViewPage from "./customers/pools/view";
import AgentBenefitViewPage from "./agent_benefits/view";
import LeadBucketViewPage from "./leads/buckets/view";
import AggregatorViewPage from "./agents/aggregators/view";
import AgentViewPage from "./agents/view";
import AgentGroupViewPage from "./agents/groups/insights";
import VisitCampaignViewPage from "./visit_campaigns/view";
import LeadProfileViewPage from "./leads/view";
import DataCaptureSummary from "./campaigns/data_captures/summary";
import AiDataReportsPage from "./campaigns/data_captures/ai_reports";
import CampaignActivityTrackerView from "./campaigns/activity";
import ActivityFootprintsOverview from "./campaigns/activity/components/location_overview";
import RecipientGroupViewPage from "./messaging/group";
import HomeDashboard from "./home";
import ExcelReportTemplatesPage from "./excel_reports";
import CreateExcelReportTemplatePage from "./excel_reports/create";
import ExcelReportTemplatePage from "./excel_reports/view";
import AllDataCapturesPage from "./campaigns/data_captures/captures";
import AccountSales from "./campaigns/sales";
import DawManagePage from "./daw";
import DawRetailersPage from "./daw/retailers";
import DawVisitsPage from "./daw/visits";
import DawLeaderboardPage from "./daw/leaderboard";
import PSAManagePage from "./psa";
import PSASamplingsPage from "./psa/samplings";
import PSAFeedbacksPage from "./psa/feedbacks";
import PSASampleRecordPage from "./psa/sample";
import PSAFeedbackPage from "./psa/feedback";
import PSAInsightsPage from "./psa/insights";
import LeadPipelineViewPage from "./leads/pipelines/view";
import LeadBucketInsightsPage from "./leads/buckets/insights";

const appRoutes = [
  {
    type: "collapse",
    name: "Home",
    key: "home",
    route: "/home",
    component: <HomeDashboard />,
    secure: true,
  },
  {
    name: "Sign Up",
    key: "sign-up-company",
    route: "/sign-up",
    component: <SignUp />,
    secure: false,
  },
  {
    name: "Sign Up",
    key: "sign-up",
    route: "/sign-up/contact",
    component: <ContactInfo />,
    secure: false,
  },
  {
    name: "Sign In",
    key: "sign-in",
    route: "/sign-in",
    component: <UserSignin />,
    secure: false,
  },
  {
    name: "Forgot Password",
    key: "forgot-password",
    route: "/forgot-password",
    component: <ForgotPwd />,
    secure: false,
  },
  {
    name: "Reset Password",
    key: "reset-password",
    route: "/reset-password",
    component: <ResetPwd />,
    secure: false,
  },
  {
    name: "Upload Vouchers",
    key: "upload-vouchers",
    route: "/upload-vouchers",
    component: <UploadVouchers />,
    secure: true,
  },
  {
    type: "collapse",
    name: "Sales",
    key: "sales",
    // icon: <Icon fontSize="small">list_alt</Icon>,
    route: "/sales",
    component: <AccountSales />,
    secure: true,
  },
  {
    type: "collapse",
    name: "Data Captures",
    key: "data-captures",
    // icon: <Icon fontSize="small">list</Icon>,
    route: "/captures",
    component: <AllDataCapturesPage />,
    secure: true,
  },
  {
    name: "Campaign",
    key: "campaign",
    route: "/campaigns/:id",
    component: <CampaignOverview />,
    secure: true,
  },
  {
    name: "Campaign Performance",
    key: "campaign",
    route: "/campaigns/:id/agent-performance",
    component: <CampaignAgentPerformance />,
    secure: true,
  },
  {
    name: "Campaign Orders",
    key: "campaign-orders",
    route: "/campaigns/:id/sales",
    component: <CampaignOrders />,
    secure: true,
  },
  {
    name: "Campaign Settings",
    key: "campaign-settings",
    route: "/campaigns/:id/settings",
    component: <CampaignView />,
    secure: true,
  },
  {
    name: "Churn Campaign",
    key: "churn-campaign",
    route: "/churn-campaigns/:id",
    component: <ChurnCampaignView />,
    secure: true,
  },
  {
    name: "Churn Campaign Customers",
    key: "churn-campaign-customers",
    route: "/churn-campaigns/:id/customers",
    component: <ChurnCustomers />,
    secure: true,
  },
  {
    name: "Churn Campaign Payments",
    key: "churn-campaign-payments",
    route: "/churn-campaigns/:id/payments",
    component: <ChurnCampaignPayments />,
    secure: true,
  },
  {
    name: "Messaging Campaign",
    key: "messaging-campaign",
    route: "/message-campaigns/:id",
    component: <MessagingCampaignView />,
    secure: true,
  },
  {
    name: "Agent Group",
    key: "agent-group",
    route: "/agent-groups/:ref",
    component: <AgentGroup />,
    secure: true,
  },
  {
    name: "Data Form",
    key: "data-form",
    route: "/data-forms/:id",
    component: <EditDataForm />,
    secure: true,
  },
  {
    name: "Create Data Form",
    key: "data-form-create",
    route: "/data-forms/create",
    component: <CreateDataForm />,
    secure: true,
  },
  {
    name: "Edit Product",
    key: "product-edit",
    route: "/products/:id",
    component: <AccountProduct />,
    secure: true,
  },
  {
    name: "Edit Shipping Rate Collection",
    key: "shipping-fee-edit",
    route: "/shipping-fees/:ref",
    component: <ShippingRateViewPage />,
    secure: true,
  },
  {
    name: "Order Page",
    key: "campaign-order",
    route: "/campaigns-orders/:ref",
    component: <OrderPage />,
    secure: true,
  },
  {
    name: "Training",
    key: "training",
    route: "/trainings/:ref",
    component: <TrainingCourse />,
    secure: true,
  },
  {
    name: "Course Quiz",
    key: "training",
    route: "/course-quizzes/:ref",
    component: <CourseTest />,
    secure: true,
  },
  {
    name: "Campaign Location CHeck-Ins",
    key: "location-check-ins",
    route: "/location-check-ins/:ref",
    component: <LocationCheckIns />,
    secure: true,
  },
  {
    name: "Data Captures",
    key: "data-captures",
    route: "/data-captures/:ref",
    component: <DataCapturesPage />,
    secure: true,
  },
  {
    name: "Data Capture",
    key: "data-capture",
    route: "/data-capture/:ref",
    component: <DataCapturePage />,
    secure: true,
  },
  {
    name: "Data Capture Overview",
    key: "data-capture-overview",
    route: "/data-captures/overview/:ref",
    component: <DataCampaignOverview />,
    secure: true,
  },
  {
    name: "License Purchase",
    key: "licenses",
    route: "/licenses/:ref",
    component: <LicensePurchasePage />,
    secure: true,
  },
  {
    name: "Location Attendances",
    key: "attendances",
    route: "/location-attendance/:ref",
    component: <CampaignLocationAttendancesPage />,
    secure: true,
  },
  {
    name: "Attendance",
    key: "attendance",
    route: "/attendances/:ref",
    component: <AttendanceViewPage />,
    secure: true,
  },
  {
    name: "Attendees",
    key: "attendees",
    route: "/attendances/records/:ref",
    component: <AttendanceEntriesPage />,
    secure: true,
  },
  {
    name: "Customer Pool",
    key: "customer-pool",
    route: "/customer-pools/:ref",
    component: <CustomerPoolViewPage />,
    secure: true,
  },
  {
    name: "Benefit",
    key: "agent-benefit",
    route: "/agent-benefits/:ref",
    component: <AgentBenefitViewPage />,
    secure: true,
  },
  {
    name: "Lead Bucket",
    route: "/leads/buckets/:ref",
    component: <LeadBucketViewPage />,
    secure: true,
  },
  {
    name: "Lead Bucket Insights",
    route: "/leads/buckets/insights/:ref",
    component: <LeadBucketInsightsPage />,
    secure: true,
  },
  {
    name: "Lead Profile",
    route: "/leads/profiles/:ref",
    component: <LeadProfileViewPage />,
    secure: true,
  },
  {
    name: "Lead Pipeline",
    route: "/leads/pipelines/:ref",
    component: <LeadPipelineViewPage />,
    secure: true,
  },
  {
    name: "Supervisor",
    key: "supervisors",
    route: "/supervisors/:ref",
    component: <AggregatorViewPage />,
    secure: true,
  },
  {
    name: "Agent",
    key: "agent",
    route: "/agents/:ref",
    component: <AgentViewPage />,
    secure: true,
  },
  {
    name: "Group Insights",
    key: "agent-groups-inisights",
    route: "/agent-groups/insights/:ref",
    component: <AgentGroupViewPage />,
    secure: true,
  },
  {
    name: "Visit Campaign",
    key: "visit-campaigns",
    route: "/visit-campaigns/:ref",
    component: <VisitCampaignViewPage />,
    secure: true,
  },
  {
    name: "Data Form Summary",
    key: "data-summary",
    route: "/data-summary/:ref",
    component: <DataCaptureSummary />,
    secure: true,
  },
  {
    name: "Data Form AI Report Builder",
    key: "ai-data-report-builder",
    route: "/data-ai-reports/:ref",
    component: <AiDataReportsPage />,
    secure: true,
  },
  {
    name: "Campaign Activity Tracker",
    key: "campaign-activity-tracker",
    route: "/campaigns/:ref/activity",
    component: <CampaignActivityTrackerView />,
    secure: true,
  },
  {
    name: "Messaging Group View",
    key: "messaging/groups",
    route: "/messaging/groups/:ref",
    component: <RecipientGroupViewPage />,
    secure: true,
  },
  {
    name: "Excel Report Templates",
    key: "excel-report-templates",
    route: "/excel-report-templates",
    component: <ExcelReportTemplatesPage />,
    secure: true,
  },
  {
    name: "Create Excel Report Template",
    key: "excel-report-templates-create",
    route: "excel-report-templates-create",
    component: <CreateExcelReportTemplatePage />,
    secure: true,
  },
  {
    name: "Excel Report Template",
    key: "excel-report-template",
    route: "/excel-report-templates/:ref",
    component: <ExcelReportTemplatePage />,
    secure: true,
  },
  {
    name: "Display Win",
    key: "campaigns/display-win/",
    route: "/campaigns/display-win/:ref",
    component: <DawManagePage />,
    secure: true,
  },
  {
    name: "Display Win Retailers",
    key: "campaigns/display-win/retailers",
    route: "/campaigns/display-win/retailers/:ref",
    component: <DawRetailersPage />,
    secure: true,
  },
  {
    name: "Display Win Retailer Visits",
    key: "campaigns/display-win/visits",
    route: "/campaigns/display-win/visits/:ref",
    component: <DawVisitsPage />,
    secure: true,
  },
  {
    name: "Display Win Retailer leaderboard",
    key: "campaigns/display-win/leaderboard",
    route: "/campaigns/display-win/leaderboard/:ref",
    component: <DawLeaderboardPage />,
    secure: true,
  },
  {
    key: "campaigns/product-sampling/",
    route: "/campaigns/product-sampling/:ref",
    component: <PSAManagePage />,
    secure: true,
  },
  {
    key: "campaigns/product-sampling/",
    route: "/campaigns/product-sampling/sample-records/:ref",
    component: <PSASamplingsPage />,
    secure: true,
  },
  {
    key: "campaigns/product-sampling/",
    route: "/campaigns/product-sampling/feedbacks/:ref",
    component: <PSAFeedbacksPage />,
    secure: true,
  },
  {
    key: "campaigns/product-sampling/",
    route: "/campaigns/product-sampling/sample-records/view/:ref",
    component: <PSASampleRecordPage />,
    secure: true,
  },
  {
    key: "campaigns/product-sampling/",
    route: "/campaigns/product-sampling/feedbacks/view/:ref",
    component: <PSAFeedbackPage />,
    secure: true,
  },
  {
    key: "campaigns/product-sampling/",
    route: "/campaigns/product-sampling/insights/:ref",
    component: <PSAInsightsPage />,
    secure: true,
  },
  // {
  //   name: "Create Advert",
  //   key: "advert-create",
  //   route: "/adverts/create",
  //   component: <CreateAdvertPage />,
  //   secure: true,
  // },
  // {
  //   name: "Advert",
  //   key: "advert-create-view",
  //   route: "/adverts/:ref",
  //   component: <AdvertViewPage />,
  //   secure: true,
  // },
];

export default appRoutes;
